import React from 'react';
import styled from 'styled-components';
import { Table, Button, Col, Row } from 'antd';
import TableActions from '../../atoms/TableActions';
import TableSearch from '../../atoms/TableSearch';
import AppTemplate from '../../templates/AppTemplate';
import './Campaigns.css';

const StyledTable = styled(Table)`
  tbody {
    tr td:nth-child(3) {
      padding: 0;
    }
    td a {
      display: block;
      padding: 16px 16px;
    }
  }
`;

const CampaignList = ({
  archived,
  toggleArchived,
  tableData,
  columns,
  showNewCampaignModal,
  handlePauseCampaigns,
  handleRunCampaigns,
  handleArchiveCampaigns,
  handleSearchTable,
  handleTableChange,
  loading,
  selectedRowKeys,
  onSelectedRowKeysChange,
  pagination,
}) => (
  <AppTemplate>
    <h1>
      Campaigns{' '}
      <Button type="primary" size="large" onClick={showNewCampaignModal}>
        New Campaign
      </Button>
    </h1>

    <Row type="flex" justify="space-between" align="middle">
      <Col span={20}>
        <TableActions
          handlePauseCampaigns={handlePauseCampaigns}
          handleRunCampaigns={handleRunCampaigns}
          handleArchiveCampaigns={handleArchiveCampaigns}
        />
      </Col>
      <Col span={4}>
        <TableSearch handleSearchTable={handleSearchTable} />
      </Col>
    </Row>

    <div className="tableContainer">
      <StyledTable
        pagination={pagination}
        rowKey="id"
        onChange={handleTableChange}
        loading={loading}
        rowSelection={{
          selectedRowKeys,
          onChange: onSelectedRowKeysChange,
        }}
        dataSource={tableData}
        columns={columns}
      />

      <Button onClick={toggleArchived} loading={loading}>
        {archived && 'Back to Unarchived Campaigns'}
        {!archived && 'View Archived campaigns'}
      </Button>
    </div>
  </AppTemplate>
);

export default CampaignList;
